import { useState } from 'react';

import { FlightSeatMapFragment } from '@websky/graphql';

export const useSeatMapToolbarProps = (seatMap: FlightSeatMapFragment) => {
	const [segmentIndex, setSegment] = useState(0);
	const [passengerIndex, setPassenger] = useState(0);

	const onToolbarButtonClick = (callback: () => void) => {
		if (segmentIndex + 1 < seatMap.segments.length) {
			setSegment(segmentIndex + 1);
			setPassenger(0);

			return;
		}

		callback();
	};

	return {
		segmentIndex,
		passengerIndex,

		setSegment,
		setPassenger,

		onToolbarButtonClick
	};
};
